<template>
    <div class="page-article">
        <!--content-->
        <SupportList />
        <div class="container" v-for="(item,index) in gameInfo" :key="index">
            <div class="single">
                <a href="#">
                  <el-image class="img-responsive" :src="imgUrl('static/images/game/'+item.path+'/top')" alt=" ">
                    <div slot="placeholder" class="img-placeholder">
                      图片加载中<span class="dot">...</span>
                    </div>
                  </el-image>
                </a>
                <div class="single-grid">
                    <h4>{{item.title}}<span v-if="item.enTitle">（{{item.enTitle}}）</span>
                    <!-- 版本：<span v-if="item.version">v {{item.version}}</span> -->
                    </h4>
                    <div class="cal">
                        <ul>
                            <li title="发布日期"><span><i class="glyphicon glyphicon-calendar"> </i>{{item.date}}</span></li>
                            <li title="最后更新日期" v-if="item.update"><span><i class="glyphicon glyphicon-refresh"> </i>{{item.update}}</span></li>
                            <li title="版本号" v-if="item.version">
                              <span v-if="checkDaysDifference(item.update)"><i class="glyphicon glyphicon-circle-arrow-up"> </i>版本号：<a :href='item.changelogUrl' target="_blank" title="点击查看完整更新日志" style="color:red;">{{item.version}}</a></span>
                              <span v-else><i class="glyphicon glyphicon-circle-arrow-up"> </i>版本号：<a :href='changelogUrl' target="_blank" title="点击查看完整更新日志">{{item.version}}</a></span>
                              </li>
                            <li title="作者" v-if="item.author && item.author.length >= 1"><span><i class="glyphicon glyphicon-user"> </i><span v-for="(group, gi) in groupAuthors(item)" :key="gi">{{group.type}}：<a v-for="(a, ai) in group.authors" :key="ai" :href='"/#/s="+a' title="点击查看Ta参与的所有游戏" target="_blank">{{a}}<i v-if="ai < group.authors.length - 1">、</i></a></span></span></li>
                            <li title="游戏评分" v-if="item.rateUrl">
                              <span ><i class="glyphicon glyphicon-thumbs-up"> </i>评分：<a :href='item.rateUrl' target="_blank" title="点击查看或给游戏打分" style="color:red;">给游戏打个分</a></span>
                              </li>
                              <li title="游戏评分" v-if="item.chouUrl">
                              <span ><i class="glyphicon glyphicon-gift"> </i>抽奖：<a :href='item.chouUrl' target="_blank" title="点击查看或给游戏打分" style="color:red;">前往参与抽奖</a></span>
                              </li>
                        </ul>

                    <h4 class="grid2"><span class="label first">标签：</span>
                        <span v-for="(t,i) in item.type" :key="i" class="label" :style="{background: tagcolorList[i] || ''}"><a :href='"/#/s=" + t' title="点击查看相关的所有游戏" target="_blank">{{t}}</a></span>
                    </h4>
                    </div>
                    <!--<div class="votes" >
                        <script type="text/javascript" charset="gb2312" src="http://likexia.com/vote/vote.asp?sid=9"></script>
                    </div>-->
                    <div class="tit">介绍</div>
                    <p>欢迎关注咱微信公众号：<a :href="settingList.article_wechat_link" :title="'微信搜索关注：' + settingList.article_wechat" target="_blank"> <b><font color="red">{{settingList.article_wechat}}</font></b></a>，可以及时获取最新游戏发布动态哦~​</p>
                    <div v-if="item.QQ">
                        <p>欢迎加入游戏交流QQ群：
                          <font color="red" v-if="!item.qqUrl">{{item.QQ}}</font>
                          <a  v-if="item.qqUrl" :href="item.qqUrl" target="_blank"><font color="red">{{item.QQ}}</font></a>
                        </p>
                    </div>
                    <br>
                    <div v-for="(content, index) in getContents(item.content)" :key="index">
                        <p>{{content}}</p>
                    </div>
                    <br>
                    <p>{{settingList.article_tip1}}</p>
                    <p>{{settingList.article_tip2}}</p>
                    <p>{{settingList.article_tip3}}</p>
                    <p>{{settingList.article_tip4}}</p>
                    <br>
                    <p>适度游戏益脑，沉迷游戏伤身</p>
                    <p>合理安排时间，享受健康生活。</p>
                    <div class="tit">游戏地址</div>
                    <div class="btn-group">
                        <a v-if="item.chouUrl" :href="item.chouUrl" title="点击参与抽奖" class="cd-read-more  hvr-wobble-top" style="background:green;" target="_blank"><i class="glyphicon glyphicon-gift"></i> 参加抽奖</a>
                        <a v-if="item.chouUrl2" :href="item.chouUrl2" title="点击参与抽奖2" class="cd-read-more  hvr-wobble-top" style="background:green;" target="_blank"><i class="glyphicon glyphicon-gift"></i> 参加抽奖2</a>
                        <a v-if="item.chouUrl3" :href="item.chouUrl3" title="点击参与抽奖3" class="cd-read-more  hvr-wobble-top" style="background:green;" target="_blank"><i class="glyphicon glyphicon-gift"></i> 参加抽奖3</a>
                        <a v-if="item.chouUrl4" :href="item.chouUrl4" title="点击参与抽奖4" class="cd-read-more  hvr-wobble-top" style="background:green;" target="_blank"><i class="glyphicon glyphicon-gift"></i> 参加抽奖4</a>
                        <a v-if="item.chouUrl5" :href="item.chouUrl5" title="点击参与抽奖5" class="cd-read-more  hvr-wobble-top" style="background:green;" target="_blank"><i class="glyphicon glyphicon-gift"></i> 参加抽奖5</a>
                        <a v-if="item.rateUrl" :href="item.rateUrl" title="点击查看或给游戏打分" class="cd-read-more  hvr-wobble-top" style="background:red;" target="_blank"><i class="glyphicon glyphicon-thumbs-up"></i> 给游戏打个分</a>
                        <a v-if="item.zhUrl" :href="item.zhUrl" title="点击开始游戏" class="cd-read-more  hvr-wobble-top" target="_blank"><i class="glyphicon glyphicon-play-circle"> </i> 中文版</a>
                        <a v-if="item.customUrl" :href="item.customUrl" :title="item.customUrlTit" class="cd-read-more  hvr-wobble-top" target="_blank"><i class="glyphicon glyphicon-play-circle"></i> {{item.customUrlTit}}</a>
                        <a v-if="item.customUrl2" :href="item.customUrl2" :title="item.customUrlTit2" class="cd-read-more  hvr-wobble-top" target="_blank"><i class="glyphicon glyphicon-play-circle"></i> {{item.customUrlTit2}}</a>
                        <a v-if="item.customUrl3" :href="item.customUrl3" :title="item.customUrlTit3" class="cd-read-more  hvr-wobble-top" target="_blank"><i class="glyphicon glyphicon-play-circle"></i> {{item.customUrlTit3}}</a>
                        <a v-if="item.customUrl4" :href="item.customUrl4" :title="item.customUrlTit4" class="cd-read-more  hvr-wobble-top" target="_blank"><i class="glyphicon glyphicon-play-circle"></i> {{item.customUrlTit4}}</a>
                        <a v-if="item.customUrl5" :href="item.customUrl5" :title="item.customUrlTit5" class="cd-read-more  hvr-wobble-top" target="_blank"><i class="glyphicon glyphicon-play-circle"></i> {{item.customUrlTit5}}</a>
                        <a v-if="item.enUrl" :href="item.enUrl" title="点击开始游戏" class="cd-read-more  hvr-wobble-top" target="_blank"><i class="glyphicon glyphicon-play-circle"> </i> 英文版</a>
                        <a v-if="item.kUrl" :href="item.kUrl" title="点击开始游戏" class="cd-read-more  hvr-wobble-top" target="_blank"><i class="glyphicon glyphicon-play-circle"> </i> K站英文版</a>
                        <a v-if="item.steamUrl" :href="item.steamUrl" title="点击开始游戏" class="cd-read-more  hvr-wobble-top" target="_blank"><i class="glyphicon glyphicon-shopping-cart"> </i> Steam版</a>
                        <a v-if="item.weiyunUrl" :href="item.weiyunUrl" title="微云网盘下载地址" class="cd-read-more  hvr-wobble-top" target="_blank"><i class="glyphicon glyphicon-download-alt"> </i> 微云网盘下载</a>
                        <a v-if="item.baiduUrl" :href="item.baiduUrl" title="百度云盘下载地址" class="cd-read-more  hvr-wobble-top" target="_blank"><i class="glyphicon glyphicon-download-alt"> </i> 百度网盘下载</a>
                        <a v-if="item.otherUrl" :href="item.otherUrl" title="其它下载地址" class="cd-read-more  hvr-wobble-top" target="_blank"><i class="glyphicon glyphicon-download-alt"> </i> 其它下载地址</a>
                        <a v-if="item.wikiUrl" :href="item.wikiUrl" title="Wiki地址" class="cd-read-more  hvr-wobble-top" target="_blank"><i class="glyphicon glyphicon-question-sign"> </i> Wiki地址</a>
                        <a v-if="item.wikiUrl2" :href="item.wikiUrl2" title="Wiki地址2" class="cd-read-more  hvr-wobble-top" target="_blank"><i class="glyphicon glyphicon-question-sign"> </i> Wiki地址2</a>
                        <a v-if="item.hhUrl" :href="item.hhUrl" title="汉化导入方式" class="cd-read-more  hvr-wobble-top" target="_blank">汉化导入方式</a>
                        <a v-if="item.jbUrl" :href="item.jbUrl" title="自动脚本导入方式" class="cd-read-more  hvr-wobble-top" target="_blank">自动脚本导入方式</a>
                        <a v-if="item.gitUrl" :href="item.gitUrl" title="Github仓库，欢迎点星" class="cd-read-more  hvr-wobble-top" style="background:#333;" target="_blank"><i class="glyphicon glyphicon-home"> </i> Github仓库</a>
                        <a v-if="item.changelogUrl" :href="item.changelogUrl" title="点击查看完整更新日志" class="cd-read-more  hvr-wobble-top" target="_blank"><i class="glyphicon glyphicon-circle-arrow-up"> </i> 更新日志</a>
                        <a v-if="item.qqUrl" :href="item.qqUrl" title="点击加入本游戏玩家交流QQ群" class="cd-read-more  hvr-wobble-top" style="background:#409eff;" target="_blank"><i class="glyphicon glyphicon-bullhorn"> </i> 玩家交流QQ群</a>
                    </div>
                  <div class="tit">游戏推荐</div>
                  <div class="btn-group">
                    <a v-for="(item,index) in tgData" :key="item.link" :href="item.link" :title="item.title" class="cd-read-more  hvr-wobble-top h5game" target="_blank" :style="{background: colorList[index] || ''}"><i class="glyphicon glyphicon-fire"></i> {{item.button}}</a>
                  </div>
                    <div class="tit">其它</div>
                    <div class="btn-group">
                        <a href="http://bbs.gityx.com" title="查看游戏攻略" class="cd-read-more  hvr-wobble-top btn-success" target="_blank"><i class="glyphicon glyphicon-question-sign"> </i> 游戏攻略</a>
                        <!--						<a href="#" title="查看英文版游戏文档" class="cd-read-more  hvr-wobble-top btn-success" target="_blank">英文文档</a>-->
                        <a :href="settingList.article_qqurl" :title="settingList.article_qqtip" class="cd-read-more  hvr-wobble-top btn-info" target="_blank"><i class="glyphicon glyphicon-bullhorn"> </i> {{settingList.article_qqbtn}}</a>
                        <a href="javascript:void(0)" title="您的支持，是我最大的动力！" class="cd-read-more  hvr-wobble-top btn-info btn-dashang" @click="open()"><i class="glyphicon glyphicon-heart"> </i> 赞助支持</a>

                    </div>
                </div>

            </div>
        </div>

        <!--//content-->
        <!--images-->
        <div class="container" v-for="item in gameInfo" :key="item.path">
            <div class="games">
                <div class="tit">游戏图鉴</div>
                <section>
                    <ul id="da-thumbs" class="da-thumbs tuijian">
                        <li>
                            <a :href="imgUrl('static/images/game/'+item.path+'/face')" rel="标题" class="b-link-stripe b-animate-go thickbox" target="_blank">
                                <img class="img" :src="imgUrl('static/images/game/'+item.path+'/face')" :alt="item.title" />
                                <img src="static/images/game/null.png" :alt="item.title" />
                                <div>
                                    <h5>封面</h5>
                                    <span>点击查看大图</span>
                                </div>
                            </a>
                        </li>
                        <li v-for="(pic,i) in item.pic" :key="i">
                            <a :href="jietuUrl('static/images/game/'+item.path+'/jietu-'+pic, item.imgExt)" :rel="item.title" class="b-link-stripe b-animate-go thickbox" target="_blank">
                              <el-image class="img" :src="jietuUrl('static/images/game/'+item.path+'/jietu-'+pic, item.imgExt)" :alt="item.title">
                                <div slot="placeholder" class="img-placeholder small">
                                  图片加载中<span class="dot">...</span>
                                </div>
                              </el-image>
                                <img src="static/images/game/null.png" :alt="item.title" />
                                <!-- <div>
                                    <h5>游戏截图</h5>
                                    <span>{{item.title}}截图{{pic}}</span>
                                </div> -->
                            </a>
                        </li>
                        <div class="clearfix"></div>
                    </ul>
                </section>

        <div class="autor-games" v-if="authorGameList && authorGameList.length > 0">
          <div class="single-grid">
          <div class="tit">Ta 投稿/汉化 的其他游戏</div>
                    
            <div
                class="col-md-3 blog-top"
                v-for="(game,index) in myData"
                :key="index">
              <router-link :to="'/game/'+game.path" :title="game.title" target="_blank">
                <div class="blog-in">
                  <div class="face-box" :title="game.title">
                    <el-image class="img-responsive" :src="jietuUrl('static/images/game/'+game.path+'/jietu-1', game.imgExt)" :alt="game.title">
                      <div slot="placeholder" class="img-placeholder home">
                        图片加载中<span class="dot">...</span>
                      </div>
                    </el-image>
                    <div class='MarkBox' v-if="game.tuijian === 1">
                      <div class='insideBox tuijian'>推荐</div>
                    </div>
                    <div class='MarkBox' v-if="game.hot === 1">
                      <div class='insideBox hot'>热门</div>
                    </div>
                    <div class='MarkBox' v-if="game.biwan === 1">
                      <div class='insideBox biwan'>必玩</div>
                    </div>
                  </div>
                  <div class="blog-grid">
                    <h4><a>{{ game.title }}
                      <span v-if="game.enTitle !== ''">（{{ game.enTitle }}）</span>
                    </a></h4>
                    <div class="date">
                      <span class="date-in" title="发布日期"><i
                          class="glyphicon glyphicon-time"> </i>{{ game.date }}</span>
                      <span class="date-in recent" title="最后更新日期" v-if="game.update"><i
                          class="glyphicon glyphicon-repeat"> </i>{{ game.update }}</span>
                      <div class="clearfix"></div>
                    </div>
                  </div>
                </div>
              </router-link>
            </div>

                    <div class="clearfix"> </div>
                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[12, 40, 80, 100]" :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
          </div>
        </div>
            </div>
        </div>
        <!--//images-->
        <!--分享 开始-->
        <!--<div class="contact">-->
        <!--<div class="container">-->
        <!--<div class="bdsharebuttonbox"><a href="" style="background:none;text-decoration:none;color:#000;font-size:14px;">分享到：</a><a href="#" class="bds_sqq" data-cmd="sqq" title="分享到QQ好友">QQ好友</a><a href="#" class="bds_weixin" data-cmd="weixin" title="分享到微信">微信</a><a href="#" class="bds_qzone" data-cmd="qzone" title="分享到QQ空间">QQ空间</a><a href="#" class="bds_tsina" data-cmd="tsina" title="分享到新浪微博">新浪微博</a><a href="#" class="bds_more" data-cmd="more">更多：</a></div>-->
        <!--<script>window._bd_share_config={"common":{"bdSnsKey":{},"bdText":"","bdMini":"2","bdMiniList":false,"bdPic":"","bdStyle":"0","bdSize":"16"},"share":{"bdSize":16}};with(document)0[(getElementsByTagName('head')[0]||body).appendChild(createElement('script')).src='http://bdimg.share.baidu.com/static/api/js/share.js?v=89860593.js?cdnversion='+~(-new Date()/36e5)];</script>-->
        <!--</div></div>-->
        <!--分享 结束-->
        <!--评论 开始-->
        <!--<div class="contact">-->
        <!--<div class="container">-->
        <!--&lt;!&ndash; 来必力City版安装代码 &ndash;&gt;-->
        <!--<div id="lv-container" data-id="city" data-uid="MTAyMC8zMzc2Mi8xMDMxNg==">-->
        <!--<script type="text/javascript">-->
        <!--(function(d, s) {-->
        <!--var j, e = d.getElementsByTagName(s)[0];-->

        <!--if (typeof LivereTower === 'function') { return; }-->

        <!--j = d.createElement(s);-->
        <!--j.src = 'https://cdn-city.livere.com/js/embed.dist.js';-->
        <!--j.async = true;-->

        <!--e.parentNode.insertBefore(j, e);-->
        <!--})(document, 'script');-->
        <!--</script>-->
        <!--<noscript> 为正常使用来必力评论功能请激活JavaScript</noscript>-->
        <!--</div>-->
        <!--&lt;!&ndash; City版安装代码已完成 &ndash;&gt;-->
        <!--</div></div>-->
        <!--评论 结束-->
    </div>
</template>

<script>
import SupportList from '@/components/Support.vue'
import imageExt from '@/mixins/imageExt'
export default {
  name: 'Article',
  mixins: [imageExt],
  components: {
    SupportList
  },
  data() {
    return {
      gameInfo: [],
      tgData: [],
      settingList: [],
      colorList: [],
      tagcolorList: [],
      authorGameList: [],
      authorName: '',
      gameType: ['primary', 'success', 'default', 'info', 'warning', 'danger', 'add1', 'add2', 'add3', 'add4', 'add5', 'add6'],
      id: this.$route.params.id,
      num: 0,
      vote: '',
      total: 0,
      currentPage: 1, // 默认显示第1页
      pagesize: 12 // 默认一次显示10条数据
    }
  },
  created() {
    this.getSetting()
    this.getArticleSetting()
    this.getTg()
  },
  computed: {
    myData: function() {
      return this.authorGameList.slice((this.currentPage - 1) * this.pagesize, this.currentPage * this.pagesize)
    },
  },
  mounted() {},
  methods: {
    groupAuthors(item) {
      const types = Array.isArray(item.author_type) ? item.author_type : (item.author_type ? [item.author_type] : [])
      const authors = item.author || []
      const groups = []
      for (let i = 0; i < authors.length; i++) {
        const type = types[i] || types[0] || '作者'
        if (groups.length > 0 && groups[groups.length - 1].type === type) {
          groups[groups.length - 1].authors.push(authors[i])
        } else {
          groups.push({ type, authors: [authors[i]] })
        }
      }
      return groups
    },
    getSetting() {
      const timeStamp = new Date().getTime()
      // 获取网站配置，存入本地储存
      this.$http.get('static/data/setting.json' + '?' + timeStamp).then(game => {
        // 如果本地有记录，对比配置版本号是否一致
        if(localStorage.getItem('settingList') && (game.data[0].version === JSON.parse(localStorage.getItem('settingList'))[0].version)){
          // 读取本地json
          this.getStaticData()
        } else {
          // 读取远程json
          this.getData()
          // 覆盖本地版本号
          localStorage.setItem('settingList', JSON.stringify(game.data))
        }
      })
    },
    getData() {
      var timeStamp = new Date().getTime()
      this.$http.get('static/data/games.json' + '?' + timeStamp).then(game => {
        localStorage.setItem('gameList', JSON.stringify(game.data))
        // 获取当前游戏详情
        var currentGame = game.data.find(item => item.path === this.id)
        if (currentGame) {
          this.gameInfo.push(currentGame)
          this.authorName = currentGame.author[0]
          document.title = currentGame.title + ' - Git游戏 - gityx.com'
          this.num = 1
          this.authorGameList = gameArr.filter(item => item.author && item.author.includes(this.authorName) && item.path !== this.id)
          this.total = this.authorGameList.length
        }
        if (this.num < 1) {
          //                            console.log(this.num)
          this.$router.push({
            path: '/'
          })
        }
      },
      game => {
        console.log('error')
      }
      )
    },
    getStaticData() {
      var gameArr = JSON.parse(localStorage.getItem('gameList'))
      if(gameArr){
        // 获取当前游戏详情
        var currentGame = gameArr.find(item => item.path === this.id)
        if (currentGame) {
          this.gameInfo.push(currentGame)
          this.authorName = currentGame.author[0]
          document.title = currentGame.title + ' - Git游戏 - gityx.com'
          this.num = 1
          this.authorGameList = gameArr.filter(item => item.author && item.author.includes(this.authorName) && item.path !== this.id)
          this.total = this.authorGameList.length
        }
        if (this.num < 1) {
          this.$router.push({
            path: '/'
          })
        }
      }else{
        this.getData()
      }
    },
    open() {
      $('.hide_box').fadeIn()
      $('.shang_box').fadeIn()
    },
    getArticleSetting() {
      var settingArr = JSON.parse(localStorage.getItem('settingList'))[0]
      if (localStorage.getItem('settingList')) {
        this.settingList = settingArr
        this.colorList = settingArr.article_colorList
        this.tagcolorList = settingArr.article_tagcolorList
      } else {
      var timeStamp = new Date().getTime()
      this.$http.get('static/data/setting.json' + '?' + timeStamp).then(res => {
        this.settingList = res.data[0]
        this.colorList = res.data[0].article_colorList
        this.tagcolorList = res.data[0].article_tagcolorList
      },
      res => {
        console.log('error')
      }
      )
      }
    },
    getTg() {
      var timeStamp = new Date().getTime()
      this.$http.get('static/data/tuiguang.json' + '?' + timeStamp).then(res => {
        this.tgData = res.data.filter(el => el.status === 1)
      },
      res => {
        console.log('error')
      }
      )
    },
    getContents(content) {
      if (!content || content.length === 0) {
        return ['这是一款放置型经营游戏。游戏虽然没什么精美的图片和动听的音乐，但还是有相当的经营乐趣。']
      }
      return content.filter(c => c && c.length > 0)
    },
    handleSizeChange(size) {
      this.pagesize = size
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage
    },
    checkDaysDifference(date) {
      const now = new Date();
      const otherDate = new Date(date); // 示例日期，根据需要替换
      const timeDifference = now.getTime() - otherDate.getTime();
      const daysDifference = timeDifference / (1000 * 60 * 60 * 24);
      return daysDifference < 7; // 更新数据属性以供模板使用
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
